import { render } from "./IconCameraPlus.vue?vue&type=template&id=385d674e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCameraPlus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "385d674e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('385d674e', __exports__)) {
    api.reload('385d674e', __exports__)
  }
  
  module.hot.accept("./IconCameraPlus.vue?vue&type=template&id=385d674e", () => {
    api.rerender('385d674e', render)
  })

}


export default __exports__